export enum InterviewType {
  phone = 'phone',
  video = 'video',
  on_site = 'on_site',
}

export interface InterviewContactDto {
  userProfileId: number | null;
  name: string;
  email: string;
}

export interface InterviewSchedulingRequestDto {
  contacts: InterviewContactDto[];
  duration: number | null;
  type: InterviewType | null;
  venueDetails?: string | null;
  additionalDetails?: string;
  schedulingPreferences?: string;
  requireFinalConfirmation?: boolean;
  customMeetingLink?: string;
}

export interface HasOpenThreadResponseDto {
  exists: boolean;
}
